import { BagFeesAction } from './actions';
import { BagFeesState } from './types';

const defaultState: BagFeesState = {};

export default function bagFeesReducer(
  state = defaultState,
  action: BagFeesAction,
): BagFeesState {
  switch (action.type) {
    case 'GET_BAG_FEES_SUCCESS': {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}
